import { Provider } from '@angular/core';
import { AppointmentActivity } from '@omni/classes/activity/appointment.activity.class';
import { ActivityService } from '@omni/services/activity/activity.service';
import { APPOINTMENT_REF_RESOLVER, AppointmentRefResolver, isDynamicsGuid } from './appointment-ref-resolver';

/**
 * The activity-backed resolver. Meeting upload swaps an uploaded meeting's `ID`
 * for its real GUID and keeps `offlineMeetingId` as the back-reference, so the
 * synced activity set is the mapping from the id a record captured to the id
 * Dynamics will accept.
 *
 * Same lookup MedicalInquiryDataService.resolveAppointmentRef performs for MI
 * uploads, made available to any service that has to bind an appointment.
 */
export const APPOINTMENT_REF_RESOLVER_PROVIDER: Provider = {
  provide: APPOINTMENT_REF_RESOLVER,
  deps: [ActivityService],
  useFactory: (activityService: ActivityService): AppointmentRefResolver => (appointmentRef: string) => {
    if (isDynamicsGuid(appointmentRef)) {
      return appointmentRef;
    }
    const uploaded = activityService.activities?.find(
      activity => activity instanceof AppointmentActivity
        && activity.offlineMeetingId === appointmentRef
        && isDynamicsGuid(activity.ID),
    );
    return uploaded?.ID ?? null;
  },
};
